"use strict";
const angular = require("angular");

/*@ngInject*/
export function identificationService($resource) {
  // AngularJS will instantiate a singleton by calling "new" on this function
  "ngInject";

  return $resource(
    "/api/users/:controller/:id",
    {
      id: "@id",
    },
    {
      //----------GET---------------
      getClients: {
        method: "GET",
        params: {
          controller: "clients",
        },
      },
      checkVatNumber: {
        method: "GET",
        params: {
          controller: "check-vat-number",
        },
      },
      checkSiret: {
        method: "GET",
        params: {
          controller: "check-siret",
        },
      },
      //----------POST---------------
      createClient: {
        method: "POST",
        params: {
          controller: "clients",
        },
      },
      createContact: {
        method: "POST",
        params: {
          controller: "contacts",
        },
      },
      createSociety: {
        method: "POST",
        params: {
          controller: "societies",
        },
      },
      createAddress: {
        method: "POST",
        params: {
          controller: "address",
        },
      },
      //----------PUT---------------
      updateContact: {
        method: "PUT",
        params: {
          controller: "contacts",
        },
      },
      updateSociety: {
        method: "PUT",
        params: {
          controller: "societies",
        },
      },
      updateAddress: {
        method: "PUT",
        params: {
          controller: "address",
        },
      },
      //----------DELETE---------------
      deleteContact: {
        method: "DELETE",
        params: {
          controller: "contacts",
        },
      },
      deleteSociety: {
        method: "DELETE",
        params: {
          controller: "societies",
        },
      },
      deleteAddress: {
        method: "DELETE",
        params: {
          controller: "address",
        },
      },
    }
  );
}

export default angular
  .module("dalApp.identification.api", [])
  .service("IdentificationAPI", identificationService).name;



// WEBPACK FOOTER //
// ./client/app/permission/identification/identification.service.js